(function ($) {
    $(document).ready(function () {
        $(".basictable").basictable();
    });
})(jQuery);
